module.exports = __webpack_public_path__ + "img/logo-vistat.3aaabaf.svg";